import moment from "moment";
// Store
import store from "@/store.js";
//Enums
import AlbumSearchTypeEnum from "@/enums/searchType.js";

export default {
    mixins: [],
    data: () => ({
        emailsCommonList: [],
        flatSelectEmail: false,
        AlbumSearchTypeEnum,
    }),
    computed: {},
    methods: {
        getIdxCurrentAlbum() {
            const uuid = this.$route.query.uuid;
            return Object.values(this.$store.state.albumes).findIndex(
                (item) => item.uuid == uuid
            );
        },
        /**
         * It takes a date and a number of days and returns the number of days between the date and the
         * number of days
         * @param objectiveDate - The date to be compared.
         * @param [dateExpiry=30] - The number of days after which the cookie will expire.
         * @returns The number of days between the date and the dateExpiry.
         */
        diffDays(objectiveDate, dateExpiry = 30) {
            const target = moment(objectiveDate);
            const today = moment().startOf('day');
            return target.diff(today, 'days');
        },
        chunk(items, size) {
            const chunks = [];
            items = [].concat(...items);

            while (items.length) {
                chunks.push(items.splice(0, size));
            }

            return chunks;
        },
        /**
         * The function organizes an array of countries by moving Mexico and USA to the beginning.
         * @param countries - an array of objects representing countries.
         * @returns an array of countries with Mexico and USA as the first two elements
         */
        topCountries(countries) {
            /* This code block is checking if the `countries` array is empty or not. If the array is
            empty, it immediately returns the same empty array */
            if (!countries.length) {
                return countries;
            }

            // If the array contains value, we carry out the operation to organize MEX and USA as first
            countries.map((item, idx) => {
                if (item.iSO === "MEX" || item.iSO === "USA") {
                    countries.splice(idx, 1);
                    countries.splice(0, 0, item);
                }
            });

            return countries;
        },
        /**
         * The function receives an email and returns an array of emails with the most common domains.
         * @param {*} email
         * @returns
         */
        buildCustomEmail(email) {
            if (email.includes("@")) {
                const [localPart, domainPart] = email.split("@");

                const filteredDomains = this.getEmailsCommon.filter((domain) =>
                    domain.startsWith(domainPart)
                );

                if (filteredDomains.length === 0) {
                    return [];
                }

                return filteredDomains.map(
                    (domain) => localPart + "@" + domain
                );
            }

            return [];
        },
        /**
         * Funcion para seleccionar un email de la lista de emails
         * @param {*} val
         */
        setValueWatchEmail(val) {
            if (!this.flatSelectEmail) {
                this.emailsCommonList = this.buildCustomEmail(val);
            } else {
                this.flatSelectEmail = false;
            }
        },
        /**
         * Función para verificar si no existe un álbum  de fotos(Venta de una reserva) y no existe un álbum de video mandamos a
         * recotizar todo el carrito
         * Forzamos actualizar el precio del carrito para los demás álbumes de videos, con esto no interferimos
         * con la lógica original para fotos
         */
        checkUpsellUpdate: async function (shoppingCart) {
            //Verificamos si contiene videos el carrito de compras
            const hasVideo = shoppingCart.some(
                (item) => item.type === AlbumSearchTypeEnum.VIDEO
            );

            if (hasVideo) {
                /* Aseguramos que en el carrito exista un video con upsell (esto debe de existir cuando el visitante agrega un
                 * album de fotos y posterior agrega un album de videos, con esto se aplica un descuento y la promocion se aplica, pasa de ser
                 * standalone a upsell) */
                const hasVideoUpsell = shoppingCart.some(
                    (item) =>
                        item.type === AlbumSearchTypeEnum.VIDEO &&
                        item?.VideoDetails?.serviceId ===
                            item?.QuotingService?.Upsell
                );

                /* Verificamos si en el carrito de compras existe el ítem de tipo room (productos de una reserva adicionales de un código  de descarga
                 * es decir que el visitante haya buscado un código de descarga de su compra y haya agregado un album adicional de foto o video
                 */
                const hasRoom = shoppingCart.some(
                    (item) => item?.type === AlbumSearchTypeEnum.ROOM
                );

                /* Verificamos si en el carrito de compras existe el ítem de tipo downloadcode (productos adicionales de un código  de descarga
                 * es decir que el visitante haya buscado un código de descarga de su compra y haya agregado un album adicional de foto o video)
                 */
                const hasDownloadCode = shoppingCart.some(
                    (item) => item?.type === AlbumSearchTypeEnum.DOWNLOADCODE
                );

                /* Esta regla es clave para evitar actualizar en todo momento todo el carrito de compras
                 * y con ello ahorramos peticiones de actualizacion de precios, por lo cual la acutalizacion ocurre bajo estos criterios:
                 */
                if (!hasVideoUpsell && (hasRoom || hasDownloadCode)) {
                    await store.dispatch("updatePriceShoppingCart");
                } else if (hasVideoUpsell && !hasRoom && !hasDownloadCode) {
                    await store.dispatch("updatePriceShoppingCart");
                }
            }
        },
        /**
         * getParkPrefix
         * @param parkId - ID del parque
         * @return PrefixPark del parque o cadena vacía si no se encuentra
         */
        getParkPrefix(parkId) {
            const park = store.state.Parks.find(
                (item) => item.ParkId === parkId
            );
            return park ? park.PrefixPark : "";
        },
        /**
         * Función para agrupar los tags de un servicio
         * @param service - objeto de servicio con tags
         * @return objeto de servicio con tags agrupados
         */
        groupServices(service) {
            const groupedTags = {};

            service.tags.forEach((tag) => {
                const key = `${tag.tag}_${tag.visitDate}_${tag.udnPrefix}_${service.serviceId}`;

                if (!groupedTags[key]) {
                    groupedTags[key] = tag; // Solo asigna el primer tag con esta clave
                }
            });

            return {
                ...service,
                tags: Object.values(groupedTags),
            };
        },
    },
};
